export function initializeEcho({
    Echo,
    Pusher,
    environment,
    runtime = {},
    target,
}) {
    const appKey =
        runtime.appKey?.trim() || environment.VITE_REVERB_APP_KEY?.trim();

    if (!appKey) {
        return null;
    }

    const host = runtime.host?.trim() || environment.VITE_REVERB_HOST;
    const port = runtime.port?.trim() || environment.VITE_REVERB_PORT;
    const scheme =
        runtime.scheme?.trim() || environment.VITE_REVERB_SCHEME || 'https';

    target.Pusher = Pusher;
    target.Echo = new Echo({
        broadcaster: 'reverb',
        key: appKey,
        wsHost: host,
        wsPort: port ?? 80,
        wssPort: port ?? 443,
        forceTLS: scheme === 'https',
        enabledTransports: ['ws', 'wss'],
    });

    return target.Echo;
}
